import type { RequestOptions } from 'http';

import { get } from 'lodash';

import type {
  ExtractDispatchFromModel,
  ExtractSelectFromModel,
  WidgetEffectParams
} from '@swf/core/store';
import type {
  ChangeClubOptionsRequest,
  ClubOptionsResponse,
  HgGetClubOptionsReply
} from '@swf/generated/types/api/v0/SwHomeGames';

import { PKR_LOADERS } from '../../constants/constants';
import type { HomeGamesWidgetModel } from '../model';

export const clubOptions = async (
  {
    clubId,
    method,
    seasonType
  }: {
    clubId: number;
    method?: RequestOptions['method'];
    seasonType?: HgGetClubOptionsReply['seasonType'];
  },
  { request, dispatch, widget: { id }, select, rootState }: WidgetEffectParams<void>
) => {
  const widgetSelect: ExtractSelectFromModel<HomeGamesWidgetModel> = select[id];
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[id];
  const loaderName = PKR_LOADERS.clubOptionsById(clubId);
  const currentOptions = widgetSelect.clubOptionsById(rootState)[clubId];

  widgetDispatch.setLoading({ isLoading: true, loaderName });

  const body = method
    ? ({
        changeClubOptions: {
          ...currentOptions,
          seasonLength: seasonType,
          seasonType
        }
      } as ChangeClubOptionsRequest)
    : { clubId };
  const response = await request<ClubOptionsResponse>({
    service: '/api/v1-preview/homegames/clubs/options',
    body,
    method: (method ?? 'GET') as never
  });
  const clubOptionsReply: HgGetClubOptionsReply = get(response, 'body.clubOptionsReply');

  if (response.body.success) {
    widgetDispatch.setClubOptions({
      response: clubOptionsReply ?? { ...currentOptions, seasonType },
      clubId
    });
  }

  widgetDispatch.setLoading({ isLoading: false, loaderName });
};
